import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';

const tooltipStyle = {
  fontFamily: 'Open Sans',
  maxWidth: '300px',
  border: '1px solid #626262',
  background: '#495C69',
  textAlign: 'left',
  zIndex: '9999',
};

export const FemaFloodZoneTooltip = () => {
  return (
    <Tooltip id="fema-flood-zone" place="right" style={tooltipStyle} clickable>
      <strong>FEMA flood zones</strong> are areas of land that have been mapped by the Federal
      Emergency Management Agency (FEMA) based on their level of flood risk. FEMA flood zones are
      designated by letters that correspond to different levels of flood risk. Visit our Methodology
      page for more information about flood zones.
    </Tooltip>
  );
};

const FemaSpecialFloodAreaTooltip = () => {
  return (
    <Tooltip id="fema-special-flood-area" place="right" style={tooltipStyle} clickable>
      A <strong>Special Flood Hazard Area (SFHA)</strong> is an area FEMA designates as having a 1%
      chance of flooding in any given year (also referred to as the base flood or 100-year flood).
      Importantly for residents, if you live in an SFHA and have a federally backed mortgage, you
      are required to purchase flood insurance. Visit our Methodology page for more information
      about SFHAs.
    </Tooltip>
  );
};

// Due to this tooltip being used in multiple places, it is exported as a component
export const FemaSpecialFloodAreaTooltipInfo = () => {
  return (
    <>
      <button
        data-tooltip-id="fema-special-flood-area"
        aria-label="fema-special-flood-area-tooltip"
        type="button"
      >
        <InformationCircleIcon className="h-5 text-primary" />
      </button>
      <FemaSpecialFloodAreaTooltip />
    </>
  );
};

export const ElevationCertificateTooltip = () => {
  return (
    <Tooltip id="elevation-certificate" place="bottom" style={tooltipStyle} clickable>
      <strong>Is your structure elevated?</strong>
      <br />
      Send an email with your elevation certificate to{' '}
      <a
        href="mailto:tdis@tamu.edu?subject=Buyers%20Aware%20Elevation%20Certificate"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        tdis@tamu.edu
      </a>
    </Tooltip>
  );
};
